import { generateErrorCode } from '../utils/ErrorUtils';
export class ExtendedError extends Error {
    constructor(message, cause, errorCodeContextInputs, displayContext) {
        super(message);
        if (cause) {
            this.cause = cause;
            if (cause instanceof Error) {
                this.causeMessage = cause.message;
            }
        }
        if (errorCodeContextInputs) {
            const errorCode = generateErrorCode(errorCodeContextInputs);
            this.errorCodeContext = Object.assign(Object.assign({}, errorCodeContextInputs), { errorCode });
        }
        if (displayContext) {
            this.displayContext = displayContext;
        }
    }
}
//# sourceMappingURL=ExtendedError.js.map